<template>
  <div>
    <navbar-component></navbar-component>
    <main>
      <page-header title="Mechanical Engineering"
                   :links="[{title:'Home', url:'/'},{title:'Academic Achievers'}]"></page-header>
      <div class="container-2">
        <section class="sidebar">
          <sidebar :active="7"></sidebar>
        </section>
        <section class="content">
          <div class="heading-black1">Academic Achievers</div>
          <tab-view class="">
            <tab-panel header="2020-21">
              <div class="grid grid-cols-3 gap-5">
                <achiever-component v-for="(achiever,index) in achievers" :key="index" :achiever="achiever"></achiever-component>
              </div>
            </tab-panel>
            <tab-panel header="2019-20"></tab-panel>
            <tab-panel header="2018-19"></tab-panel>
            <tab-panel header="2017-18"></tab-panel>
            <tab-panel header="2016-17"></tab-panel>
          </tab-view>
        </section>
      </div>
      <key-recruiters></key-recruiters>
    </main>
    <footer-component></footer-component>
  </div>
</template>
<script>
import NavbarComponent from "@/components/Navbar.vue";
import FooterComponent from "@/components/Footer.vue";
import PageHeader from "@/components/PageHeader";
import Sidebar from "@/views/academics/mechanical/Sidebar";
import KeyRecruiters from "@/components/KeyRecruiters";
import TabView from "primevue/tabview";
import TabPanel from "primevue/tabpanel";
import AchieverComponent from "@/components/AchieverComponent";

export default {
  name: "landing-page",
  components: {
    NavbarComponent,
    PageHeader,
    Sidebar,
    FooterComponent,
    KeyRecruiters,
    TabView,
    TabPanel,
    AchieverComponent
  },
  data() {
    return {
      achievers: [{
        name: 'Student Name dsasd',
        image: 'https://via.placeholder.com/150',
        score: '60%'
      },
        {
          name: 'Student Name dsasd',
          image: 'https://via.placeholder.com/150',
          score: '60%'
        },
        {
          name: 'Student Name dsasd',
          image: 'https://via.placeholder.com/150',
          score: '60%'
        }]
    }
  }

}
</script>
<style lang="scss" scoped>
</style>
